export const SESSION_ACCESS_DENIED_CODE = "session_access_denied";
export const SESSION_ACCESS_DENIED_MESSAGE =
  "Session not found or access denied";

export const SESSION_CHAT_API_PATHS = [
  "/get-chat-history",
  "/add-message",
  "/start-session-with-message",
  "/delete-session",
  "/rename-session",
  "/export-session",
  "/export-chat",
];

export function isSessionAccessDenied(error) {
  const status = error?.response?.status;
  if (status !== 403) {
    return false;
  }

  const detail = error.response?.data?.detail;
  if (typeof detail === "object" && detail?.error_code === SESSION_ACCESS_DENIED_CODE) {
    return true;
  }
  if (detail === SESSION_ACCESS_DENIED_MESSAGE) {
    return true;
  }

  const requestUrl = error.config?.url || "";
  return SESSION_CHAT_API_PATHS.some((path) => requestUrl.includes(path));
}

export function getSessionAccessDeniedMessage() {
  return "This conversation is not available.";
}
